//@flow

import styled from "styled-components"

export default styled.div`
  display: flex;
  flex-direction: row;
  padding: 0 1rem 1rem 1rem;
  height: 490px;
`



// WEBPACK FOOTER //
// ./src/Kiosk/HistoryModal/HistoryContainer.js